import axios from "axios";
import React, { useEffect, useState } from "react";
import { serverLink, shortCode } from "../../../resources/url";
import Loader from "../../common/loader/loader";
import PageName from "../../common/pagename/pagename";
import Banner from "../../common/banner/banner";
import _ from "lodash";
import {Button, Modal} from "react-bootstrap";

    const GoverningCouncil = () => {
        const [governingCouncil, setgoverningCouncil] = useState([]);
        const [loading, setLoading] = useState(true);

        useEffect(() => {
            async function getgoverningCouncil() {
                const result = await axios.get(`${serverLink}leadership/list`);
                setgoverningCouncil(result.data.filter(x=>x.Category === "Governing Council"));
                setLoading(false);
            }
            getgoverningCouncil();
        }, []);
    return (
        <>
            {loading ? <Loader /> : ""}
            <PageName page={"Governing Council"} />

            <Banner
                Title={"Governing Council"}
                breadcrumb={["Home", "Governing Council"]}
            />
            <div className="container mb-5 pb-3">
                <div className="col-md-12">
                    <h3 className="text-center my-5">Governing Council</h3>
                    <div className="d-flex align-items-center align-content-between flex-column">
                        <div className="row">
                            {governingCouncil?.map((senate, index) => (
                                <div className=" " key={index}>
                                    <img
                                        style={{ height: 300, width: 300 }}
                                        src={senate.ImagePath !== null ? senate.ImagePath.includes("simplefileupload") ? senate.ImagePath :  `${serverLink}public/uploads/${shortCode}/leaderships_uploads/${senate.ImagePath}` : ""}
                                        // src={
                                        //     !_.isEmpty(senate.ImagePath)
                                        //         ? `${serverLink}public/uploads/leaderships_uploads/${senate.ImagePath}`
                                        //         : `${serverLink}public/uploads/no-image.jpeg`
                                        // }
                                        alt={senate.FullName}
                                    />
                                    <div className="col-md-12">
                                        <h6 className="text-center mt-1 w-100">
                                            {senate.Title} {senate.FullName}
                                        </h6>
                                        <p className="text-center mb-5">{senate.Designation}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default GoverningCouncil;